import { proNavigator } from "single-spa/react-app/ProNavigator";

import { MARKET_BUILDER_STATE } from "../components/customIndustryAgentBanner/useCustomIndustryAgentBanner";

/** `showRunError` lets the builder show the failed run it was opened for; any other way in
 *  lets that error go. */
export const navigateToMarketBuilder = (countryId?: number | null, { showRunError = false } = {}): void => {
    const params: Record<string, unknown> = {};

    if (countryId != null) {
        params.initialCountry = countryId;
    }

    if (showRunError) {
        params.showRunError = true;
    }

    void proNavigator.go(MARKET_BUILDER_STATE, params);
};
